import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaSignOutAlt, FaMoneyBillWave, FaCalendarTimes, FaClock, FaBook, FaRegGrinBeam, FaCalendarCheck } from "react-icons/fa";
import { GrAnnounce } from "react-icons/gr";
import { MdSpaceDashboard } from "react-icons/md";
import { GiRuleBook, GiTakeMyMoney } from "react-icons/gi";
import { AiFillProfile, AiFillSchedule } from "react-icons/ai";
import { IoSettingsSharp, IoCalendarSharp, IoDocument } from "react-icons/io5";
import { HiDocumentReport } from "react-icons/hi";
import { GrDocumentPerformance } from "react-icons/gr";
import { MdCoPresent, MdMenuBook } from "react-icons/md";
import { FaBalanceScale } from "react-icons/fa";
import { RiRefund2Fill } from "react-icons/ri";
import { HiMiniUserGroup } from "react-icons/hi2";
import { LuLayoutDashboard } from "react-icons/lu";
import { FcOvertime } from "react-icons/fc";
import { TbUserCog } from "react-icons/tb";
import { FaUserCircle } from "react-icons/fa";
import axios from 'axios';
import "./sidebar.css";

const iconMap = {
  HiMiniUserGroup: <HiMiniUserGroup />,
  MdSpaceDashboard: <MdSpaceDashboard />,
  GrAnnounce: <GrAnnounce />,
  FaBook: <FaBook />,
  GiRuleBook: <GiRuleBook />,
  IoCalendarSharp: <IoCalendarSharp />,
  HiDocumentReport: <HiDocumentReport />,
  GrDocumentPerformance: <GrDocumentPerformance />,
  MdCoPresent: <MdCoPresent />,
  FaMoneyBillWave: <FaMoneyBillWave />,
  FaCalendarTimes: <FaCalendarTimes />,
  FaClock: <FaClock />,
  IoDocument: <IoDocument />,
  FaRegGrinBeam: <FaRegGrinBeam />,
  RiRefund2Fill: <RiRefund2Fill />,
  AiFillProfile: <AiFillProfile />,
  FaBalanceScale: <FaBalanceScale />,
  MdMenuBook: <MdMenuBook />,
  IoSettingsSharp: <IoSettingsSharp />,
  LuLayoutDashboard: <LuLayoutDashboard />,
  GiTakeMyMoney: <GiTakeMyMoney />,
  FaCalendarCheck: <FaCalendarCheck />,
  FcOvertime: <FcOvertime />,
  TbUserCog: <TbUserCog />,
  FaUserCircle: <FaUserCircle />,
};

const SideBar = ({ children, employeeName }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [routes, setRoutes] = useState([]);
  const [myInfoRoutes, setMyInfoRoutes] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [mainRes, myInfoRes] = await Promise.all([
          axios.get('https://backend.ems.hiradentallab.com/api/panel-pages/panel/AccountsPanel'),
          axios.get('https://backend.ems.hiradentallab.com/api/panel-pages/my-info/AccountsPanel')
        ]);

        const fetchedMyInfoRoutes = myInfoRes.data.map(item => ({
          ...item,
          icon: iconMap[item.icon] || item.icon,
        }));
        setMyInfoRoutes(fetchedMyInfoRoutes);

        const myInfoPaths = new Set(fetchedMyInfoRoutes.map(r => r.path));

        const fetchedRoutes = mainRes.data.filter(pp => !myInfoPaths.has(pp.page.path)).map(pp => ({
          path: pp.page.path,
          name: pp.page.name,
          icon: iconMap[pp.page.icon] || pp.page.icon,
          subRoutes: pp.page.subRoutes,
        }));
        setRoutes(fetchedRoutes);
      } catch (error) {
        console.error('Error fetching pages:', error);
      }
    };

    fetchData();
  }, []);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const isActive = (path) => location.pathname.startsWith(path);

  const handleItemClick = (path, e) => {
    e.preventDefault();
    navigate(path);
    if (window.innerWidth <= 1024) {
      setIsOpen(false);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <>
      <div className="sidebar-container">
        <button className="hamburger" onClick={toggleSidebar}>
          <FaBars />
        </button>
        <div className={`sidebar ${isOpen ? "open" : ""}`}>
          <section className="routes">
            {routes.map((route, index) => (
              <NavLink
                to={route.path}
                key={index}
                className={`link ${isActive(route.path) ? "active" : ""}`}
                onClick={(e) => handleItemClick(route.path, e)}
              >
                <div className="icon">{route.icon}</div>
                <div className={`link_text ${isOpen ? "visible" : "hidden"}`}>
                  {route.name}
                </div>
              </NavLink>
            ))}
            {/* My Info Heading */}
            <div className="my-info-heading">MY INFO</div>
            {myInfoRoutes.map((item, index) => (
              <NavLink
                to={item.path}
                key={index}
                className={`link ${isActive(item.path) || (item.subRoutes && item.subRoutes.some(subRoute => isActive(subRoute.path))) ? "active" : ""}`}
                onClick={(e) => handleItemClick(item.path, e)}
              >
                <div className="icon">{item.icon}</div>
                <div className={`link_text ${isOpen ? "visible" : "hidden"}`}>
                  {item.name}
                </div>
              </NavLink>
            ))}
          </section>
          <div className="sidebar-footer">
            <span className="employee-name">{employeeName}</span>
            <button className="sign-out" onClick={handleLogout}>
              <FaSignOutAlt />
              {isOpen && "Sign Out"}
            </button>
          </div>
        </div>
      </div>
      <main>{children}</main>
    </>
  );
};

export default SideBar;